module.exports = __webpack_public_path__ + "img/hero-sp@2x.feecf039.jpg";